import APP_CONFIG, { EStoreID } from 'config/App.config';
import React from 'react';
import EasyPaisaTag from '../EasyPaisa/EasyPaisaTag';
import MpesaTag from '../Mpesa/MpesaTag';

const MobileWalletTag = () => {
  const mobileWalletTagMap: any = {
    [EStoreID.MAFPAK]: <EasyPaisaTag />,
    [EStoreID.MAFKEN]: <MpesaTag />,
  };
  return mobileWalletTagMap[APP_CONFIG.storeId] || <div />;
};

export default MobileWalletTag;
